module.exports = __webpack_public_path__ + "static/media/fish.4a21a429.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/fish.svg
// module id = 483
// module chunks = 0